const filterButtons = document.querySelectorAll(".filter-button");
const projectCards = document.querySelectorAll(".project-card");
const projectForm = document.querySelector("#projectForm");
const formStatus = document.querySelector("#formStatus");
const newsletterForm = document.querySelector("#newsletterForm");
const newsletterStatus = document.querySelector("#newsletterStatus");

filterButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const filter = button.dataset.filter;

    filterButtons.forEach((item) => {
      item.classList.remove("is-active");
      item.setAttribute("aria-pressed", "false");
    });
    button.classList.add("is-active");
    button.setAttribute("aria-pressed", "true");

    projectCards.forEach((card) => {
      const matches = filter === "all" || card.dataset.category === filter;
      card.classList.toggle("is-hidden", !matches);
    });
  });
});

projectForm.addEventListener("submit", (event) => {
  event.preventDefault();
  const data = new FormData(projectForm);
  const name = data.get("name");

  formStatus.textContent = `Thanks, ${name}. Your project draft is ready for review.`;
  projectForm.reset();
});

newsletterForm.addEventListener("submit", (event) => {
  event.preventDefault();
  const input = newsletterForm.querySelector("input");
  input.value = "";
  input.placeholder = "Subscribed";
  newsletterStatus.textContent = "You're on the list. Fresh campaign picks will land in your inbox.";
});
